"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _utils = require("../utils");

var quadrantsPlugin = {
  id: "quadrants",
  beforeDraw: function beforeDraw(chart) {
    var ctx = chart.ctx,
        _chart$chartArea = chart.chartArea,
        left = _chart$chartArea.left,
        top = _chart$chartArea.top,
        right = _chart$chartArea.right,
        bottom = _chart$chartArea.bottom;
    ctx.save();
    ctx.strokeStyle = "rgba(0, 0, 0, 0.6)";
    ctx.beginPath();
    ctx.moveTo((right - left) / 2 + left, top);
    ctx.lineTo((right - left) / 2 + left, bottom);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(left, (top - bottom) / 2 + bottom);
    ctx.lineTo(right, (top - bottom) / 2 + bottom);
    ctx.stroke();
    ctx.restore();
  },
  afterDraw: function afterDraw(chart, args, options) {
    var _quadrantDescriptions5, _quadrantDescriptions6, _quadrantDescriptions7, _quadrantDescriptions8;

    var ctx = chart.ctx,
        _chart$chartArea2 = chart.chartArea,
        left = _chart$chartArea2.left,
        top = _chart$chartArea2.top,
        right = _chart$chartArea2.right,
        bottom = _chart$chartArea2.bottom;
    var device = options.device,
        quadrantDescriptions = options.quadrantDescriptions,
        showQuadrantDescriptions = options.showQuadrantDescriptions;
    var fontSize = device === "MOBILE" ? 10 : 20;
    ctx.save();
    ctx.font = fontSize + "px arial";
    ctx.lineWidth = 1;
    ctx.textAlign = "center";
    ctx.fillStyle = "rgba(0, 0, 0, 0.48)";

    if (showQuadrantDescriptions) {
      var _quadrantDescriptions, _quadrantDescriptions2, _quadrantDescriptions3, _quadrantDescriptions4;

      ctx.fillStyle = "rgba(0, 0, 0, 0.68)";
      ctx.fillRect(left, top, right - left, bottom - top);
      ctx.fillStyle = "#ffffff";

      if (quadrantDescriptions != null && (_quadrantDescriptions = quadrantDescriptions.topLeft) != null && _quadrantDescriptions.description) {
        var lines = (0, _utils.getLines)(ctx, quadrantDescriptions.topLeft.description, (right - left) / 2.5);
        lines.forEach(function (l, i) {
          ctx.fillText(l, (right - left) / 4 + left, top + 60 + i * fontSize);
        });
      }

      if (quadrantDescriptions != null && (_quadrantDescriptions2 = quadrantDescriptions.topRight) != null && _quadrantDescriptions2.description) {
        var _lines = (0, _utils.getLines)(ctx, quadrantDescriptions.topRight.description, (right - left) / 2.5);

        _lines.forEach(function (l, i) {
          ctx.fillText(l, (right - left) / 4 * 3 + left, top + 60 + i * fontSize);
        });
      }

      if (quadrantDescriptions != null && (_quadrantDescriptions3 = quadrantDescriptions.bottomLeft) != null && _quadrantDescriptions3.description) {
        var _lines2 = (0, _utils.getLines)(ctx, quadrantDescriptions.bottomLeft.description, (right - left) / 2.5);

        _lines2.forEach(function (l, i) {
          ctx.fillText(l, (right - left) / 4 + left, bottom - 40 - (_lines2.length - i) * fontSize);
        });
      }

      if (quadrantDescriptions != null && (_quadrantDescriptions4 = quadrantDescriptions.bottomRight) != null && _quadrantDescriptions4.description) {
        var _lines3 = (0, _utils.getLines)(ctx, quadrantDescriptions.bottomRight.description, (right - left) / 2.5);

        _lines3.forEach(function (l, i) {
          ctx.fillText(l, (right - left) / 4 * 3 + left, bottom - 40 - (_lines3.length - i) * fontSize);
        });
      }

      ctx.font = "bold " + fontSize + "px arial";
    }

    if (quadrantDescriptions != null && (_quadrantDescriptions5 = quadrantDescriptions.topLeft) != null && _quadrantDescriptions5.title) {
      ctx.fillText(quadrantDescriptions.topLeft.title, (right - left) / 4 + left, top + 30);
    }

    if (quadrantDescriptions != null && (_quadrantDescriptions6 = quadrantDescriptions.topRight) != null && _quadrantDescriptions6.title) {
      ctx.fillText(quadrantDescriptions.topRight.title, (right - left) / 4 * 3 + left, top + 30);
    }

    if (quadrantDescriptions != null && (_quadrantDescriptions7 = quadrantDescriptions.bottomLeft) != null && _quadrantDescriptions7.title) {
      ctx.fillText(quadrantDescriptions.bottomLeft.title, (right - left) / 4 + left, bottom - 20);
    }

    if (quadrantDescriptions != null && (_quadrantDescriptions8 = quadrantDescriptions.bottomRight) != null && _quadrantDescriptions8.title) {
      ctx.fillText(quadrantDescriptions.bottomRight.title, (right - left) / 4 * 3 + left, bottom - 20);
    }

    ctx.restore();
  }
};
var _default = quadrantsPlugin;
exports["default"] = _default;